/**
 * El nombre del fichero de un informe (Personalizar informes, F5, 29-09-2026): con
 * marca, el de la empresa («frutas-ejemplo-registro-…pdf»); sin marca, el de siempre
 * («ulture-pest-…»). Sin acentos ni signos: vale en cualquier sistema y en un adjunto.
 */
import type { MarcaInformes } from "./tipos";

export const PREFIJO_ULTURE = "ulture-pest";

export function slugFichero(texto: string | null | undefined, tope = 40): string {
  return String(texto ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, tope)
    .replace(/-+$/g, "");
}

export function prefijoFichero(marca: MarcaInformes | null | undefined): string {
  return (marca && slugFichero(marca.nombre)) || PREFIJO_ULTURE;
}
